export default {
  switchAccount: "Ganti Akun",
  login: "Log in",
  loginFirst: "Log In terlebih dahulu",
  start: "Mulai Jawab",
  hasHistory: "Anda sebelumnya sudah menjawab sebagian pertanyaan,",
  loadHistory: "mau lanjutkan pertanyaan sebelumnya?",
  cancel: "Batal",
  confirm: "Konfirmasi",
  contact: "Mengisi info kontak berpeluang mendapat hadiah ekstra!",
  completed: "Selamat! Anda menyelesaikan survei",
  leaveMessage: "Tinggalkan kontak Anda bisa mendapat kesempatan undi hadiah",
  enterEmail: "Silakan masukkan email Anda:",
  enterPhone: "Silakan masukkan nomor ponsel Anda:",
  submit: "Kirim",
  leave: "Tidak mengisi dulu, tinggalkan survei",
  submitted: "Sudah kirim,",
  thanks: "terima kasih atas kepercayaan dan dukungan Anda",
  opinion: "Silakan sampaikan pendapat Anda",
  prev: "Sebelumnya",
  next: "Selanjutnya",
  unlikely: "Tidak mungkin",
  likely: "Kemungkinan besar",
  claimYourRewards: "Ini adalah hadiah untuk Anda",
  rewardSent: "Hadiah sudah dibagikan",
  checkInGame: "Silakan cek di dalam game",
  copy: "Salin",
  copied: "Berhasil disalin",
  selectTips: "Silakan pilih opsi",
  multipleTips:
    "Pertanyaan ini adalah pilihan ganda. Silakan pilih beberapa opsi",
  leastChoose: "Maksimal pilih xxx",
  maxChoose: "Minimal pilih xxx",
  mustAnswer: "Silakan jawab pertanyaan ini",
  mustWrite: "Silakan diisi",
  checkEmail: "Silakan masukkan formal email yang tepat",
  checkPhone: "Silakan masukkan formal nomor ponsel yang tepat",
  isAnswer: "Anda sudah menjawab",
  unStart: "Event belum terbuka",
  end: "Event sudah berakhir",
  server: "Pilih Server",
  role: "Pilih karakter",
  common: "Sistem sibuk, coba lagi",
  title: "Kuisioner",
  titleAward: "Survei berhadiah",
  leastWord: "Angka yang Anda masukkan kurang dari angka minimum xxx",
  maxWord: "Angka yang Anda masukkan sudah melebihi angka terbesar xxx",
  singleChoose: "Pilihan Tunggal",
  multiChoose: "Pilihan Ganda",
  matrix: "Pertanyaan Matriks",
  score: "Pertanyaan Skor",
  textLimit: "(xx-yyy huruf)",
  coverGiftTitle: "Selesaikan survei untuk klaim hadiah",
  "-20001": "Belum login",
  "-20002": "Parameter yang diperlukan tidak ada",
  "-20003": "Survei tidak ditemukan",
  "-20004": "Konfigurasi survei sedang berlangsung",
  "-20005": "Survei dihentikan",
  "-20006": "Event survei belum dimulai",
  "-20007": "Event survei telah berakhir",
  "-20008": "Sudah menjawab",
  "-20010": "Pembagian hadiah gagal",
  "-20011": "Hadiah untuk survei ini sudah dibagikan",
  "-20012": "Belum menjawab",
  "-20016": "ID game tidak valid",
};
